import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, Settings, LogOut, Grid, Heart } from 'lucide-react';
import { User as UserType } from '../types';
interface ProfileDropdownProps {
  user: UserType;
  isOpen: boolean;
  onClose: () => void;
}
export function ProfileDropdown({
  user,
  isOpen,
  onClose
}: ProfileDropdownProps) {
  if (!isOpen) return null;
  return <AnimatePresence data-id="element-244">
      <motion.div initial={{
      opacity: 0,
      y: 10,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 10,
      scale: 0.95
    }} className="absolute right-0 top-full mt-2 w-72 bg-white rounded-xl shadow-xl border border-gray-100 overflow-hidden z-50" onClick={e => e.stopPropagation()} data-id="element-245">
        <div className="p-4 border-b border-gray-100" data-id="element-246">
          <div className="flex items-center gap-3 mb-2" data-id="element-247">
            <img src={user.avatar} alt={user.name} className="w-10 h-10 rounded-full object-cover" data-id="element-248" />
            <div data-id="element-249">
              <p className="font-semibold text-gray-900" data-id="element-250">{user.name}</p>
              <p className="text-xs text-gray-500" data-id="element-251">{user.username}</p>
            </div>
          </div>
          <p className="text-xs text-gray-500" data-id="element-252">Personal Account</p>
        </div>

        <div className="p-2" data-id="element-253">
          <button className="w-full flex items-center gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors text-left text-sm font-medium text-gray-700" data-id="element-254">
            <Grid className="w-4 h-4" data-id="element-255" />
            Your Boards
          </button>
          <button className="w-full flex items-center gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors text-left text-sm font-medium text-gray-700" data-id="element-256">
            <Heart className="w-4 h-4" data-id="element-257" />
            Liked Pins
          </button>
          <button className="w-full flex items-center gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors text-left text-sm font-medium text-gray-700" data-id="element-258">
            <Settings className="w-4 h-4" data-id="element-259" />
            Settings
          </button>
        </div>

        <div className="p-2 border-t border-gray-100" data-id="element-260">
          <button className="w-full flex items-center gap-3 p-2 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors text-left text-sm font-medium text-gray-700" data-id="element-261">
            <LogOut className="w-4 h-4" data-id="element-262" />
            Log out
          </button>
        </div>
      </motion.div>
    </AnimatePresence>;
}